import { useTranslation } from 'react-i18next'

import { Plus } from '@phosphor-icons/react'

import { Button } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AddReturnMethodButton = ({ onAdd }) => {
  const { t } = useTranslation()

  return (
    <Styles.AddReturnMethodContainer>
      <Button variant="text" onClick={onAdd}>
        <Plus size={24} />
        {t('Añadir nuevo método')}
      </Button>
    </Styles.AddReturnMethodContainer>
  )
}

export default AddReturnMethodButton
